interface AffiliateCTAProps {
  programme: string;
  courseName: string;
  url: string;
  price: string;
  /** For internal tracking only — not rendered */
  commission?: string;
  badgeText?: string;
}

export function AffiliateCTA({
  programme,
  courseName,
  url,
  price,
  badgeText,
}: AffiliateCTAProps) {
  return (
    <div className="border border-[#0078d4] rounded p-4 flex flex-col gap-3" style={{ backgroundColor: 'var(--surface-container)' }}>
      <div className="flex items-start justify-between gap-3">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <span className="text-[10px] font-bold px-1.5 py-0.5 rounded uppercase tracking-wider" style={{ color: 'var(--text-tertiary)', border: '1px solid var(--outline-variant)', backgroundColor: 'var(--surface-container-low)' }}>
              AD
            </span>
            <span className="text-[11px]" style={{ color: 'var(--text-tertiary)' }}>{programme}</span>
            {badgeText && (
              <span className="text-[10px] font-bold text-white bg-[#0078d4] px-1.5 py-0.5 rounded uppercase tracking-wider">
                {badgeText}
              </span>
            )}
          </div>
          <p className="text-[14px] font-semibold leading-snug" style={{ color: 'var(--text-primary)' }}>{courseName}</p>
        </div>
        <p className="text-[16px] font-bold text-[#0078d4] shrink-0">{price}</p>
      </div>

      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer sponsored"
        className="flex items-center justify-center gap-2 px-4 py-2 bg-[#0078d4] hover:bg-[#106ebe] text-white text-[13px] font-semibold rounded transition-colors"
      >
        View course
        <span className="material-symbols-outlined text-[16px]">open_in_new</span>
      </a>

      <p className="text-[10px] leading-normal italic" style={{ color: 'var(--text-tertiary)' }}>
        AD: We earn a commission on qualifying purchases at no extra cost to you.
      </p>
    </div>
  );
}
